import { useCallback } from "react"

import toast from "react-hot-toast"
import { FiArrowRight, FiCheckCircle } from "react-icons/fi"
import { useLocation, useNavigate } from "react-router-dom"

import { TRIP_DATA_STORAGE_KEY } from "../../constants/chat"

import { getVehicleLabel } from "../../utils/tripDataExtractor"

import { FillFormButton, SummaryCard, SummaryChip, SummaryGrid, SummaryTitle } from "./styles"

const TripSummaryCard = ({ tripData, onFilled }) => {
   const navigate = useNavigate()
   const location = useLocation()

   const handleFillForm = useCallback(() => {
      try {
         sessionStorage.setItem(TRIP_DATA_STORAGE_KEY, JSON.stringify(tripData))
         onFilled?.()

         if (location.pathname !== "/app/request") {
            navigate("/app/request")
         } else {
            window.dispatchEvent(new Event("gotruck_ai_trip_fill"))
         }

         toast.success("Trip details pre-filled from AI chat. Please review and confirm.")
      } catch {
         toast.error("Failed to pre-fill trip data")
      }
   }, [tripData, navigate, location.pathname, onFilled])

   const vehicleLabel = tripData?.data?.item_size ? getVehicleLabel(tripData.data.item_size) : null

   return (
      <SummaryCard>
         <SummaryTitle>
            <FiCheckCircle color="#22c55e" />
            Trip Details Ready
         </SummaryTitle>
         <SummaryGrid>
            {tripData?.data?.cargo_type && (
               <SummaryChip>
                  <span>Cargo</span>
                  {tripData.data.cargo_type === "CONTAINER" ? "Container" : "Loose Goods"}
               </SummaryChip>
            )}
            {vehicleLabel && (
               <SummaryChip>
                  <span>Truck</span>
                  {vehicleLabel}
               </SummaryChip>
            )}
            {tripData?.startAddress && (
               <SummaryChip>
                  <span>From</span>
                  {tripData.startAddress.length > 25
                     ? tripData.startAddress.slice(0, 25) + "..."
                     : tripData.startAddress}
               </SummaryChip>
            )}
            {tripData?.endAddress && (
               <SummaryChip>
                  <span>To</span>
                  {tripData.endAddress.length > 25 ? tripData.endAddress.slice(0, 25) + "..." : tripData.endAddress}
               </SummaryChip>
            )}
            {tripData?.data?.cargo_category && (
               <SummaryChip>
                  <span>Category</span>
                  {tripData.data.cargo_category}
               </SummaryChip>
            )}
         </SummaryGrid>
         <FillFormButton onClick={handleFillForm}>
            Fill Booking Form <FiArrowRight />
         </FillFormButton>
      </SummaryCard>
   )
}

export default TripSummaryCard
